import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import * as R from 'ramda'

const useStyles = makeStyles((theme) => ({
  boxFontSize: {
    backgroundColor: '#ffffff',
    minWidth: '100px',
    boxShadow: '1px 1px #a7a4a4',
  },
  fontOptions: {
    borderBottom: '1px solid #ece8e8',
    '&:hover': {
      backgroundColor: '#ece8e8',
    },
  },
}))

const fontSizes = [
  { label: 'Small', size: 3 },
  { label: 'Medium', size: 4 },
  { label: 'Large', size: 5 },
  { label: 'Extra Large', size: 6 },
]

const getSizeLabel = (size) => {
  return R.o(R.prop('label'), R.find(R.propEq('size', size)))(fontSizes)
}

const FontSizeSelector = (props) => {
  const { fontSize, currentState, onChange } = props

  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)
  const [currentSize, setCurrentSize] = useState(
    R.isNil(currentState.fontSize) ? fontSize : currentState.fontSize,
  )

  const onClose = () => {
    setIsOpen(false)
  }

  const onOpen = () => {
    setIsOpen(true)
  }

  const handleChangeSize = (event, size) => {
    event.preventDefault()
    onChange(size)
    setCurrentSize(size)
    onClose()
  }

  return (
    <div aria-haspopup="true" className="relative w-2/5 sm:w-2/6">
      <div className="rdw-option-wrapper p-2" onClick={onOpen}>
        {getSizeLabel(currentSize)}
      </div>
      {isOpen ? (
        <div className="absolute z-10">
          <div className={classes.boxFontSize}>
            {fontSizes.map((item) => {
              return (
                <div
                  key={item.size}
                  onMouseDown={(event) => handleChangeSize(event, item.size)}
                  className={clsx(
                    'p-4 cursor-pointer text-center',
                    classes.fontOptions,
                  )}
                >
                  {item.label}
                </div>
              )
            })}
          </div>
        </div>
      ) : undefined}
    </div>
  )
}

export default FontSizeSelector
